import { Module } from 'vuex';
import { RootState } from 'frontend/types';

interface LearningPathV2Url {
  learningPathUrl?: string;
}

const learningPathV2Url: Module<LearningPathV2Url, RootState> = {
  namespaced: true,
  state: {
    learningPathUrl: undefined,
  },
  getters: {
    learningPathUrl: state => state.learningPathUrl,
  },
  mutations: {
    setValue(state: LearningPathV2Url, value: string): void {
      state.learningPathUrl = value;
    },
  },
};

export default learningPathV2Url;
